'use client'
import FadeTransition from '@/app/components/common/FadeTransition'
import { AvailableInputTypes, SM_BREAKPOINT } from '@/app/constants'
import { useMediaQuery } from '@uidotdev/usehooks'
import dynamic from 'next/dynamic'
import { FC, useRef } from 'react'

type OverlayProps = {
	openedInput?: AvailableInputTypes
	disableScroll?: boolean
	openInput: (name: AvailableInputTypes) => void
	onClick?: () => void
}

const Overlay: FC<OverlayProps> = ({
	openedInput,
	openInput,
	onClick,
	disableScroll = true,
}) => {
	const nodeRef = useRef<HTMLDivElement>(null)
	const isMobile = useMediaQuery(SM_BREAKPOINT)

	// useEffect(() => {
	//   if (disableScroll && isMobile) {
	//     document.body.style.overflow = openedInput ? 'hidden' : 'auto'
	//   }
	// }, [isMobile, openedInput])

	const handleOverlayClick = () => {
		onClick && onClick()
		openInput(null)
	}

	return (
		<FadeTransition timeout={300} in={openedInput !== null} ref={nodeRef}>
			<div onClick={handleOverlayClick} className="overlay" ref={nodeRef} />
		</FadeTransition>
	)
}

export default dynamic(() => Promise.resolve(Overlay), {
	ssr: false,
})
